import React from 'react';
import { useTransition } from 'react-spring';
import Overlay from '../Overlay';
import { ModalContainer, ContentContainer, ButtonContainer } from './styles/Modal.style';
import { IconButton } from '@oneaudi/unified-web-components';

interface ModalProps {
  handleIsOpen: () => void;
  isOpen: boolean;
  children: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ isOpen, handleIsOpen, children }) => {
  const modalTransition = useTransition(isOpen, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
    config: { duration: 400 },
  });

  const handleStopProgagation = (e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
  };

  return modalTransition.map(({ item, key, props }) => {
    return item ? (
      <Overlay key={key} props={props} isOpen={isOpen} handleIsOpen={handleIsOpen} zIndex={980}>
        <ModalContainer
          key={key}
          style={props}
          aria-modal="true"
          onClick={handleStopProgagation}
          data-testid="modal-container"
        >
          <ButtonContainer>
            <IconButton
              icon="cancel"
              onClick={handleIsOpen}
              size="md"
              variant="secondary"
              data-testid="modal-close-button"
            />
          </ButtonContainer>
          <ContentContainer>{children}</ContentContainer>
        </ModalContainer>
      </Overlay>
    ) : null;
  });
};

export default Modal;
